export default "__VITE_ASSET__595b52b9__"